export default `vec3 Q;
    float d=1.,a;
    Q=p; d=a=1.;
    for(int j=0;j++<8;)
      d=min(d,(length(Q)-.5)/a),
      Q.xz*=rotate2D(ceil(atan(Q.z,Q.x)/1.05-.5)*1.05),
      Q.x-=1., a*=3., Q*=3.;
    return d;
  }`